import GalleryLayout from './GalleryLayout'

export default GalleryLayout
